module.exports = __webpack_public_path__ + "static/media/bg4.572b2579.jpg";